import axios from 'axios'

export const UPLOAD_ACCORDION_SECTION_ENDPOINT = window?.drupalSettings?.accordionWidget?.ajax?.uploadAccordionSectionUrl;
export default async function ({hotelId, identifier, wid}) {
  const formData = new FormData();
  formData.append('hotelId', hotelId);
  formData.append('identifier', identifier);
  formData.append('wid', wid);

  return await axios.post(UPLOAD_ACCORDION_SECTION_ENDPOINT, formData)
}
